import script from "./ProduitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProduitsView.vue?vue&type=script&setup=true&lang=js"

import "./ProduitsView.vue?vue&type=style&index=0&id=3fb83a10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb83a10"]])

export default __exports__